import { Config } from '../config';
import { Form } from './form';
import { RecaptchaV2View } from '../view/recaptcha-v2-view';
import { Order } from '../config/order';
import { FormTypes } from './form-types';
import { Translations } from '../config/translations';
import { RecaptchaV2Validator } from '../validators/recaptcha-v2-validator';

export class RecaptchaV2Form  extends Form {

    type = FormTypes.RecaptchaV2;
    view: RecaptchaV2View = new RecaptchaV2View();

    grecaptcha: any;
    data: any;
    submitCallback: any;

    constructor() {
        super();
    }
    
    init = async (config: Config, callback: any) => {
        await super.init(config, callback);
        this.validators.push(new RecaptchaV2Validator(this.isRecaptchaVerified));
        return Promise.resolve();
    }

    render = () => {
        this.view.render();
        return Promise.resolve();
    }

    renderCheckbox = async (grecaptcha: any, errorMessage: string, data: any, submitCallback: any) => {
        this.grecaptcha = grecaptcha;
        this.data = data;
        this.submitCallback = submitCallback;

        const message = !errorMessage ? Translations.CAPTCHA_IS_REQUIRED : errorMessage;
        this.view.showRecaptchaMessage(message);

        if (!this.data.recaptchaTokenV2) {
            this.view.renderCheckbox(grecaptcha, this.recaptchaVerifyCallback);
        } else {
            this.view.resetCheckbox(grecaptcha);
        }

        return Promise.resolve();
    }

    recaptchaVerifyCallback = (tokenV2: any) => {
        this.data.recaptchaTokenV2 = tokenV2;
        this.submitCallback();
    }

    isRecaptchaVerified = (): boolean => {
        return !this.data ? true : this.data.recaptchaTokenV2 !== undefined && this.data.recaptchaTokenV2.length > 0;
    }

    submit(order: Order) {
        if (this.data) {
            order.recaptchaTokenV2 = this.data.recaptchaTokenV2;
        }
        return Promise.resolve(order);
    }

}
